export enum ModalSize {
  MINI = 'mini',
  TINY = 'tiny',
  SMALL = 'small',
  LARGE = 'large',
  FULLSCREEN = 'fullscreen',
}
